const body = document.body;
const fabNav = document.querySelector('.navigation--fab');
const fabToggle = fabNav.querySelector('.btn__fab--toggle');

function openFab() {
  fabNav.classList.add('active');
  document.body.classList.add('fab__is-active');
}
  
function closeFab() {
  fabNav.classList.remove('active');
  document.body.classList.remove('fab__is-active');
}

function isFabOpen() {
  return fabNav.classList.contains('active');
}

if (fabToggle) {
  fabToggle.addEventListener('click', (event) => {
    event.stopPropagation(); // prevent the document click handler from immediately closing it
    fabNav.classList.toggle('active');
    document.body.classList.toggle('fab__is-active');
  });  

  document.addEventListener('click', (event) => {
    if (!isFabOpen()) return;
    
    const clickedInsideFab = fabNav.contains(event.target);
    if (!clickedInsideFab) {
      closeFab();
    }
  });

  fabNav.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isFabOpen()) {
      closeFab();
    }
  });

  function animateActionButton() {
    fabNav.style.opacity = window.scrollY > 0 ? 1 : 0;
  }
    
  animateActionButton();
  window.onscroll = function () {
    animateActionButton();
  };
}

window.addEventListener('resize', function () {
  if (window.innerWidth >= 992) {
    fabNav.classList.remove('active');
    document.body.classList.remove('fab__is-active');
  }
});
